import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react';

interface PlayoffInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const PlayoffInfoModal: React.FC<PlayoffInfoModalProps> = ({
                                                                    isOpen,
                                                                    onClose,
                                                                  }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay/>
      <ModalContent>
        <ModalHeader>Playoff Scheduling Info</ModalHeader>
        <ModalCloseButton/>
        <ModalBody>
          <VStack align="start" spacing={3}>
            <Text>
              Use the <strong>"Schedule Game"</strong> button to queue playoff games. The system
              will automatically find the next unscheduled playoff game in the selected league
              and assign the specified court and time slot.
            </Text>
            <Text>
              After scheduling, the game will open in a new tab where you can begin scoring.
            </Text>
            <Text>Switch between leagues using the tabs to view different playoff brackets.</Text>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
